module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai17-f0c330467d19f73e8a99eeefd8bf0e4f.jpg";